import React, { useState} from "react";
import { Family} from "../pageInside/Rolle"

function computeRemainingSlots(groupedByRole, adminUserActiveRole, isFamily = false) {
    
    const referenceMax = {
        maxRoyalite: isFamily ? Infinity : (adminUserActiveRole.maxRoyalite || 0),
        maxSeller: isFamily ? Infinity : (adminUserActiveRole.maxSeller || 0),
        maxProducer: isFamily ? Infinity : (adminUserActiveRole.maxProducer || 0),
        maxAssociate: isFamily ? Infinity : (adminUserActiveRole.maxAssociate || 0),
        maxInvestment: isFamily ? Infinity : (adminUserActiveRole.maxInvestment || 0),
        maxAdmin: isFamily ? Infinity : (adminUserActiveRole.maxAdmin || 0)
      };
  
    const roleMap = {
    Royalty: "maxRoyalite",
      Seller: "maxSeller",
      Provider: "maxProducer",
      Associate: "maxAssociate",
      Investment: "maxInvestment",
      Administrator: "maxAdmin"
    };
  
    return groupedByRole.map(group => {
      const roleName = group._id;
      const count = group.count || 0;
      const maxKey = roleMap[roleName] || null;
  
      if (!maxKey || referenceMax[maxKey] === undefined) return null;
  
      const maxQuantite = referenceMax[maxKey];
      const quantiteRestante = maxQuantite - count;
  
      return {
        name: roleName,
        count,
        max: maxQuantite,
        restant: quantiteRestante >= 0 ? quantiteRestante : 0
      };
    }).filter(Boolean); // Supprime les null
  }


const thStyle = {
    borderBottom: '2px solid #ccc',
    textAlign: 'left',
    padding: '10px',
    backgroundColor: '#f0f0f0'
  };
  
  const tdStyle = {
    borderBottom: '1px solid #eee',
    padding: '10px'
  };

  const AdminSlotTable = ({ objt }) => {
let isFamily = Family()
    let data = computeRemainingSlots(objt.groupedByRole, objt.userRole, isFamily )

    return (
      <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '20px' }}>
        <thead>
          <tr>
            <th style={thStyle}>User Name</th>
            <th style={thStyle}>Quantité Ajoutée</th>
            <th style={thStyle}>Max Quantité</th>
            <th style={thStyle}>Quantité Restante</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr key={index}>
              <td style={tdStyle}>{item.name}</td>
              <td style={tdStyle}>{item.count}</td>
              <td style={tdStyle}>{item.max}</td>
              <td style={tdStyle}>{item.restant}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  export default AdminSlotTable;